import { Component, Vue, Prop, Inject, Watch, Emit } from 'vue-property-decorator';
import { PropOptions } from 'vue';
import { Multiselect } from 'vue-multiselect';
import FieldValidationErrors from '@/components/errors/FieldValidationErrors.vue';
import selectOnTab from '@/components/directives/selectOnTab-directive';
import noAutoComplete from '@/components/directives/noAutoComplete-directive';

@Component({
    name: 'Emails',
    components: {
        Multiselect,
        FieldValidationErrors
    },
    directives: {
        selectOnTab,
        noAutoComplete
    }
})
export default class EmailsInput extends Vue {
    @Prop({ required: true, default: [] } as PropOptions<string[]>)
    emails!: string[];

    @Prop({ required: false, default: false } as PropOptions<boolean>)
    required!: boolean;

    @Prop({ required: true, default: '' } as PropOptions<string>)
    subtitle!: string;

    @Inject('validator')
    $validator: any;

    showInvalidEmail: boolean = false;

    ariaUpdateMessage: string = '';

    setAccessibilityAttributes() {
        let element = $(this.$el);
        setTimeout(function () {
            element.find('.multiselect__tag-icon').attr({ 'tabindex': '0', 'role': 'button', 'aria-label': 'Remove', 'title': 'Remove' });
            element.find(".multiselect__input").attr({ 'aria-hidden': 'true' });
            element.find('.multiselect__element')
                   .find('.multieselect__option')
                   .find('.option__desc')
                   .find('.option__title').attr({ 'role': 'alert', 'aria-label': 'List updated with one suggestion. Press enter to add this email', 'title': 'List updated with one suggestion. Press enter to add this email' });
        }, 50);
    }

    @Emit('open')
    dropdownOpened() {
        this.setAccessibilityAttributes();
    }

    onEmailAdded(newEmail: string) {
        this.setAccessibilityAttributes();

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,63})+$/.test(newEmail)) {
            if (!this.emails.includes(newEmail)) {
                this.emails.push(newEmail);
                this.ariaUpdateMessage = "Added " + newEmail;
            }
        }
        else {
            this.showInvalidEmail = true;
        }
    }

    onEmailRemoved(removedEmail: string) {
        this.ariaUpdateMessage = "Removed " + removedEmail;
    }

    selectHighlightedOption() {
        var textEntered = $(this.$el).find(".multiselect__input").val();
        //@ts-ignore
        var isEnterEvent = event.which === 13;
        //@ts-ignore
        var isOptionSelectionEvent = event.currentTarget.className === 'multiselect__option multiselect__option--highlight';
        if (textEntered && !isEnterEvent && !isOptionSelectionEvent) {
            $(this.$el).find('.multiselect__option--highlight:not(.multiselect__option--selected)').trigger($.Event('click'));
        }
    }

    inputChanged() {
        this.setAccessibilityAttributes();
    }

    @Watch('emails')
    @Emit('update:emails')
    onEmailsUpdated() {
        this.showInvalidEmail = false;
        return this.emails;
    }
}
